export default {
  width: 16,
  height: 11,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.414 3.012 7.84 10.586.267 3.012 2.693.586 7.84 5.733 12.988.586l2.426 2.426Z" />
  `
}
